import './App.css';
import { BrowserRouter, useLocation } from 'react-router-dom';
import React, { useEffect } from 'react';
import Routes from "./routes.js";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App(props) {
  console.log('get root props', props)
  return (
    <BrowserRouter>
      <ScrollToTop />
      <div className="App">
        <Routes childProps={props} />
      </div>
    </BrowserRouter>
  );
}

export default App;
